module.exports = __webpack_public_path__ + "static/img/bear.36231f91.png";